import type { GlobalState } from '../../types';

import { reportClientError } from '../../../util/clientErrorReporter';

const CONNECTION_EVIDENCE_COOLDOWN_MS = 30_000;
const lastReportedAtByTransition = new Map<string, number>();

export function reportConnectionStateTransition(
  previousState: GlobalState['connectionState'],
  nextState: GlobalState['connectionState'],
  now = Date.now(),
) {
  if (!previousState || !nextState || previousState === nextState) {
    return;
  }

  const transition = `${previousState}->${nextState}`;
  const lastReportedAt = lastReportedAtByTransition.get(transition);
  if (lastReportedAt !== undefined && now - lastReportedAt < CONNECTION_EVIDENCE_COOLDOWN_MS) {
    return;
  }

  lastReportedAtByTransition.set(transition, now);

  reportClientError({
    kind: 'runtime',
    mode: 'immediate',
    message: 'Connection state transitioned',
    metadata: {
      source: 'connection-state',
      transition,
      previousState,
      nextState,
    },
  });
}

export const __testOnly = {
  resetConnectionEvidenceLogState() {
    lastReportedAtByTransition.clear();
  },
};
